import { z } from 'zod';

export const performanceDashboardFiltersSchema = z.object({
  ano: z.number().optional(),
  rede: z.string().optional(),
  escola: z.number().optional(),
  aluno: z.number().optional(),
  serie: z.number().optional(),
  turma: z.number().optional(),
  categoria: z.number().optional(),
  modelo: z.string().optional(),
});

export type PerformanceDashboardUrlFilters = z.infer<typeof performanceDashboardFiltersSchema>;

export type PerformanceDashboardFilterKey = keyof PerformanceDashboardUrlFilters;
